var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as io from 'io-ts/es6';
import * as E from 'fp-ts/es6/Either';
import axios from 'axios';
export const AppConfigCodec = io.intersection([
    io.type({
        apiEndpoint: io.string,
        authRedirectUrl: io.string,
    }),
    io.partial({
        authAuthority: io.string,
        authClientId: io.string,
        notes: io.string,
        midwayAuthApiEndpoint: io.string,
    }),
]);
const handleErrors = (errors) => {
    throw errors;
};
export const loadConfigGenericFromFile = (data, configCodec) => __awaiter(void 0, void 0, void 0, function* () {
    return E.getOrElse(handleErrors)(configCodec.decode(data));
});
export const loadConfigGeneric = (configPath = 'config/config.json', baseURL = '/', configCodec) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios.get(configPath, { baseURL: baseURL, withCredentials: true });
    return loadConfigGenericFromFile(response.data, configCodec);
});
export const loadConfig = (configPath = 'config/config.json', baseURL = '/') => __awaiter(void 0, void 0, void 0, function* () { return loadConfigGeneric(configPath, baseURL, AppConfigCodec); });
